const DEV = process.env.NODE_ENV === 'development'

// eslint-disable-next-line no-console
export const log = (...args: unknown[]) => DEV && console?.log && console.log(...args)
